import { array, func } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import withProps from 'recompose/withProps'

import View from '../View'

const RangeButtons = scope(
  consumeProps({
    ranges: array.isRequired,
    updateUsing: func.isRequired,
  }),

  withProps(({ ranges, updateUsing }) => ({
    options: ranges.map(range => ({
      ...range,
      style: { backgroundColor: range.color },
      onClick: () => updateUsing('rangeKey', range.key),
    })),
  })),

  exposeProps([
    'options',
  ]),
)(View)

RangeButtons.displayName = 'RangeButtons'

export default RangeButtons



// WEBPACK FOOTER //
// ./src/components/RangeEditor/SettingButtons/RangeButtons/index.js